import { IAction, isType } from '@zaibot/fsa';
import { fork, put, select, SelectEffect, takeEvery } from 'redux-saga/effects';
import { INote, INoteShared, isNote, isSharedNote } from '../../types';
import START_CHAT from '../notes/actions/START_CHAT';
import { notechatBatch, notechatEditor, notechatResource } from './resource';
import LOGGEDOUT from '../../auth/actions/LOGGEDOUT';

import AUTHENTICATED from '../../auth/actions/AUTHENTICATED';
import NOTECHAT_LOADED from './actions/NOTECHAT_LOADED';
import { selectors as metaSelectors } from '../../meta/selectors';
import { notesEditor } from '../notes/resource';
import { hack } from '../../browser/launch';
import STOP_CHAT from '../notes/actions/STOP_CHAT';

export function* rootSaga(): Iterable<any> {
    yield fork(notechatResource.saga);
    yield fork(notechatEditor.saga);
    yield fork(notechatBatch.saga);
    yield fork(signalNoteChatLoadWhenAuthenticated);
    yield fork(signalNoteChatReset);     
    yield fork(signalStartNoteChat);
    yield fork(signalNoteChatChange);
    yield fork(signalNoteChatListSuccess); 
}

function* signalNoteChatLoadWhenAuthenticated() {
    yield takeEvery([AUTHENTICATED], 
    function*(action: IAction<any,any>){
        if (isType(action, AUTHENTICATED)) {
            let selectionDocument: SelectEffect = yield select(metaSelectors.docId);
            let selectionDocumentId: any = selectionDocument;
            const documentId = selectionDocumentId;
            yield put(notechatResource.actions.LIST({ params: { documentId } }));
        }
    });
}

function* signalNoteChatListSuccess() {
    yield takeEvery([notechatResource.actions.LIST_SUCCESS, 
        ], function*(action: IAction<any,any>){
            if (isType(action, notechatResource.actions.LIST_SUCCESS)) {
            yield put(NOTECHAT_LOADED({}));
        }
    });
}

function* signalNoteChatReset() {
    yield takeEvery(LOGGEDOUT, function*(action: IAction<any,any>){
        if (isType(action, LOGGEDOUT)) {
            yield put(notechatResource.actions.RESET({ }));
            yield put(notechatEditor.actions.RESET({ }));
        }
    });
}

function* signalStartNoteChat() {
    yield takeEvery(START_CHAT, 
        function*(action: IAction<any,any>){
            if (isType(action, START_CHAT)) {
                var note=action.payload.item;
                var creatingChat = (yield select(notechatEditor.selectors.creating)) as boolean;
                if (note && !creatingChat) {
                    if (isSharedNote(note)) {
                        yield put(notechatEditor.actions.CREATE({
                            item: {
                                userId: (note as INoteShared).userId,
                                noteId: (note as INoteShared).id,
                                text: '',
                            },
                        }));                                                  
                    } else if (isNote(note)) {
                        yield put(notechatEditor.actions.CREATE({
                            item: {
                                userId: (note as INote).userId,
                                noteId: (note as INote).id,
                                text: '',
                            },
                        }));                         
                    }
                }                
            }
    });
}

function* signalNoteChatChange() {
    yield takeEvery([
        notesEditor.actions.READ,
        notechatResource.actions.CREATE_SUCCESS,
        notechatResource.actions.CREATE_CANCEL,
        notechatResource.actions.CREATE_FAILURE,        
        notechatResource.actions.UPDATE_SUCCESS,
        notechatResource.actions.UPDATE_CANCEL,
        notechatResource.actions.UPDATE_FAILURE,     
        notechatResource.actions.DELETE_SUCCESS,
        notechatResource.actions.DELETE_CANCEL,      
        ], function*(action: IAction<any,any>){        
        if (isType(action, notesEditor.actions.READ)) {
            yield put(notechatResource.actions.RESET({ }));
            yield put(notechatEditor.actions.RESET({ }));
            yield put(notechatBatch.actions.RESET({ }));               
            let selectionDocument: SelectEffect = yield select(metaSelectors.docId);
            let selectionDocumentId: any = selectionDocument;
            const documentId = selectionDocumentId;
            yield put(notechatResource.actions.LIST({ params: { documentId } }));
        } else if (isType(action, notechatResource.actions.CREATE_SUCCESS) ||
            isType(action, notechatResource.actions.UPDATE_SUCCESS) ||
            isType(action, notechatResource.actions.UPDATE_FAILURE) ||
            isType(action, notechatResource.actions.DELETE_SUCCESS) ||
            isType(action, notechatResource.actions.CREATE_CANCEL) ||
            isType(action, notechatResource.actions.CREATE_FAILURE) ||            
            isType(action, notechatResource.actions.UPDATE_CANCEL) ||
            isType(action, notechatResource.actions.DELETE_CANCEL)             
        ) {
            const flyoverVisible = hack.store.getState().flyover.visible;
            if (flyoverVisible) {
                yield put(STOP_CHAT({ }));
            }
            yield put(notechatEditor.actions.RESET({ }));       
            let selectionDocument: SelectEffect = yield select(metaSelectors.docId);
            let selectionDocumentId: any = selectionDocument;
            const documentId = selectionDocumentId;
            yield put(notechatResource.actions.LIST({ params: { documentId } }));                 
        }

    });
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/notechat/sagas.tsx